import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { onAuthStateChanged } from 'firebase/auth';
import { getPersonalSecretaryAuth, isPsFirebaseConfigured } from '../firebase/ps-firebase-init';

/**
 * Home (`/ps`): send guests to `/ps/login` with `rurl` so they return after sign-in.
 * When Firebase is not configured or Auth is unavailable, allow home (config hint).
 */
export const psFirebaseGuestRedirectToLoginGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  if (!isPsFirebaseConfigured()) {
    return true;
  }
  const auth = getPersonalSecretaryAuth();
  if (!auth) {
    return true;
  }
  return new Promise<boolean>((resolve) => {
    const unsub = onAuthStateChanged(auth, (user) => {
      unsub();
      if (user) {
        resolve(true);
      } else {
        void router.navigate(['/ps/login'], {
          queryParams: { rurl: state.url },
        });
        resolve(false);
      }
    });
  });
};

/** Firebase Auth only — Personal Secretary does not use Supabase session. */
export const psFirebaseAuthGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  if (!isPsFirebaseConfigured()) {
    void router.navigate(['/ps']);
    return false;
  }
  const auth = getPersonalSecretaryAuth();
  if (!auth) {
    void router.navigate(['/ps']);
    return false;
  }
  return new Promise<boolean>((resolve) => {
    const unsub = onAuthStateChanged(auth, (user) => {
      unsub();
      if (user) {
        resolve(true);
      } else {
        void router.navigate(['/ps/login'], {
          queryParams: { rurl: state.url },
        });
        resolve(false);
      }
    });
  });
};
